/* eslint-disable @next/next/no-img-element */
// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */

import { StyledButton } from '@/components/atoms'
import route_list from '@/constant/routeUrl'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useInView } from 'react-intersection-observer'
import { trackingOnView } from '@/helpers/datalayer'
import app_config from '@/constant/config'

const BlogCard = ({ item, index }: any) => {
	const router = useRouter()
	const { t } = useTranslation('blog')
	const { ref, inView } = useInView({
		/* Optional options */
		threshold: 0,
	})

	useEffect(() => {
		const title = `Artikel Blog - ` + item.title
		const detailUrl = window.location.origin + route_list.blogDetail(item.slug)

		trackingOnView(
			'artikel',
			'view_list_artikel',
			item.id,
			title,
			detailUrl,
			`${Number(index) + 1}`
		)
	}, [inView])

	return (
		<button
			onClick={() => router.push(route_list.blogDetail(item.slug))}
			key={`blog-lis-${index}`}
			className='tw-mb-6 tw-text-left tw-flex md:tw-flex-col tw-flex-col-reverse tw-bg-white tw-rounded-xl'
		>
			<div
				className='tw-mb-0 tw-ml-auto tw-w-full tw-shrink-0 tw-grow-0 tw-basis-auto'
				ref={ref}
			>
				<div
					className='tw-relative tw-overflow-hidden md:tw-rounded-t-lg md:tw-rounded-b-none tw-rounded-b-lg tw-bg-cover tw-bg-no-repeat '
					data-te-ripple-init
					data-te-ripple-color='light'
				>
					<img
						src={item.img}
						className='tw-w-full tw-h-[225px] tw-object-cover'
						alt=''
					/>
				</div>
			</div>

			<div className='tw-mr-auto tw-w-full tw-shrink-0 tw-grow-0 tw-basis-auto tw-p-4'>
				<div className='tw-flex tw-flex-row tw-gap-2'>
					<p className='tw-text-neutral-500'>
						<small>{item.date}</small>
					</p>
					<div className='tw-mb-3 tw-flex tw-gap-2 tw-items-center tw-text-sm tw-font-medium tw-text-danger tw-justify-start'>
						<div className='tw-bg-gray-200 tw-px-2 tw-py-1 tw-text-dark-green tw-text-xs'>
							{item.type}
						</div>
						{/* <div className='tw-bg-gray-200 tw-px-2 tw-py-1 tw-text-dark-green tw-text-xs'>Economy</div> */}
					</div>
				</div>
				<h5 className='tw-mb-3 md:tw-text-xl tw-text-lg tw-font-bold tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-30% tw-to-light-green tw-to-70% tw-text-left'>
					{item.title}
				</h5>

				<p
					className='tw-text-neutral-500 tw-text-sm'
					dangerouslySetInnerHTML={{ __html: item.description }}
				></p>
				<div className='tw-flex tw-justify-between tw-items-center md:tw-mt-0 tw-pt-4'>
					<h1 className=' tw-text-md tw-text-dark-green tw-text-sm tw-font-semibold'>
						By {item.author}
					</h1>
					<StyledButton
						title={t('blog.read_more')}
						className='btn-dark-to-light-green-gradient tw-text-white tw-font-semibold md:tw-text-md tw-text-xs tw-items-center  tw-px-5 md:tw-py-2 tw-py-1 tw-rounded-full md:tw-flex '
						onClick={() => router.push(route_list.blogDetail(item.slug))}
					/>
				</div>
			</div>
		</button>
	)
}

export default BlogCard
